<template>
  <span>
    <template v-if="multiple">
      <common-multi-selector
        v-if="deep === 1"
        :data-source="rootSourceProxy"
        v-model="valueProxy"
      />
      <area-cascade-multi-selector
        v-else
        :deep="deep"
        :provinces="rootSource"
        v-model="valueProxy"
        :separator="separator"
        :show-prefix="showPrefix"
        :placeholder="placeholder"
        :hidden-values="hiddenValues"
        :disabled-values="disabledValues"
      />
    </template>
    <template v-else>
      <common-single-selector
        v-if="deep === 1"
        :data-source="rootSourceProxy"
        v-model="valueProxy"
      />
      <area-cascade-selector
        v-else
        :deep="deep"
        :provinces="rootSource"
        v-model="valueProxy"
        :separator="separator"
        :show-prefix="showPrefix"
        :placeholder="placeholder"
        :hidden-values="hiddenValues"
        :disabled-values="disabledValues"
      />
    </template>
  </span>
</template>
<script>
import CommonSingleSelector from "@/components/selector/CommonSingleSelector";
import CommonMultiSelector from "@/components/selector/CommonMultiSelector";
import AreaCascadeMultiSelector from "@/components/selector/area/CascadeMultiSelector";
import AreaCascadeSelector from "@/components/selector/area/CascadeSelector";
import Arrays from "@/utils/extensions/Arrays";
function filterHidden(dataSource, hiddenValues) {
  if (!Arrays.isNotEmpty(dataSource)) {
    return [];
  }
  if (!Arrays.isNotEmpty(hiddenValues)) {
    return dataSource;
  }
  return dataSource.filter((it) => !hiddenValues.includes(it.value));
}
function assembleDisable(dataSource, disabledValues) {
  if (!Arrays.isNotEmpty(dataSource)) {
    return [];
  }
  if (!Arrays.isNotEmpty(disabledValues)) {
    return dataSource;
  }
  return dataSource.map((it) => {
    if (disabledValues.includes(it.value)) {
      return { ...it, disabled: true };
    }
    return it;
  });
}
export default {
  name: "tree-cascade-selector",
  components: {
    AreaCascadeSelector,
    AreaCascadeMultiSelector,
    CommonMultiSelector,
    CommonSingleSelector,
  },
  props: {
    rootSource: {
      type: Array,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    showPrefix: {
      type: Boolean,
      default: false,
    },
    separator: {
      type: String,
      default: "/",
    },
    unit: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    value: {
      type: [Array, Number],
    },
    hiddenValues: {
      type: Array,
    },
    disabledValues: {
      type: Array,
    },
    deep: {
      type: Number,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  computed: {
    rootSourceProxy() {
      const { deep, rootSource } = this.$props;
      if (deep !== 1) {
        return rootSource;
      }
      const { hiddenValues, disabledValues } = this.$props;
      const array = filterHidden(rootSource, hiddenValues);
      return assembleDisable(array, disabledValues);
    },
    valueProxy: {
      get() {
        return this.$props.value;
      },
      set(value) {
        this.$emit("change", value);
      },
    },
  },
  mounted() {},
};
</script>
